<template>
  <div id="app">
    <!-- 1. 顶部全局导航栏 -->
    <!-- <header class="global-header">
      <div class="header-inner">
        <div class="logo"></div>
        
        <nav class="top-menu"> -->

          <!-- <keep-alive>
            <router-link to="/" exact-active-class="active-link" v-if="$route.meta.keepAlive">
              前台商城演示
            </router-link>
          </keep-alive> -->
          <!-- 使用 router-link 进行大模块切换 -->
        
<!--           
          <router-link to="/dev/dashboard" active-class="active-link">
            开发者/压测后台
          </router-link> -->
<!-- 
          <router-link to="/dev/audioChat" active-class="active-link">
            文字转语音
          </router-link> -->
        <!-- </nav> -->
      <!-- </div> -->
    <!-- </header> -->

    <!-- 2. 路由视图：根据 URL 显示不同的页面 -->
    <div class="main-view">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 全局样式重置 */
body { margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif; background-color: #f5f7fa; }

/* 顶部导航栏样式 */
.global-header {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  height: 60px;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.logo {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.top-menu {
  display: flex;
  gap: 20px;
}

.top-menu a {
  text-decoration: none;
  color: #666;
  font-size: 15px;
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.3s;
}

.top-menu a:hover {
  background-color: #f0f2f5;
  color: #333;
}

/* 选中状态样式 */
.top-menu a.active-link {
  background-color: #e6f7ff;
  color: #1890ff;
  font-weight: bold;
}

.main-view {
  height: 100vh;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* Element UI 弹层：白底、蓝系文字、圆角；偏圆润、略加粗避免过细 */
.el-message,
.el-message-box,
.el-dialog,
.el-notification {
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei UI", "Microsoft YaHei",
    -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  -webkit-font-smoothing: antialiased;
}

.el-message {
  min-width: 300px;
  padding: 14px 18px !important;
  background: #fff !important;
  border: 1px solid rgba(66, 83, 255, 0.22) !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 28px rgba(10, 28, 68, 0.12) !important;
}

.el-message--success,
.el-message--warning,
.el-message--info,
.el-message--error {
  background: #fff !important;
  border-color: rgba(66, 83, 255, 0.22) !important;
}

.el-message .el-message__content {
  color: #2f4ad8 !important;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.55;
}

.el-message .el-message__icon {
  color: #4253ff !important;
}

.el-message-box {
  padding-bottom: 12px;
  background: #fff !important;
  border: 1px solid rgba(66, 83, 255, 0.15) !important;
  border-radius: 14px !important;
  box-shadow: 0 12px 40px rgba(10, 28, 68, 0.14) !important;
  overflow: hidden;
}

.el-message-box__header {
  padding-top: 22px;
}

.el-message-box__title {
  color: #2f4ad8 !important;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.el-message-box__content {
  color: #3d52c4 !important;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.7;
}

.el-message-box__message p {
  margin: 0;
  color: inherit !important;
}

.el-message-box__btns {
  padding-top: 8px;
}

.el-message-box__btns .el-button {
  font-size: 14px;
  font-weight: 500;
  padding: 10px 18px;
}

.el-message-box__btns .el-button--default {
  border-radius: 10px;
  color: #4253ff !important;
  border-color: rgba(66, 83, 255, 0.45) !important;
  background: #fff !important;
}

.el-message-box__btns .el-button--primary {
  border-radius: 10px;
  border: none !important;
  background: linear-gradient(135deg, #4253ff 0%, #3546e8 100%) !important;
}

.el-dialog {
  border-radius: 14px !important;
  overflow: hidden;
  border: 1px solid rgba(66, 83, 255, 0.12);
  box-shadow: 0 16px 48px rgba(10, 28, 68, 0.16) !important;
}

.el-dialog__header {
  padding: 18px 20px 12px;
  border-bottom: 1px solid rgba(66, 83, 255, 0.1);
}

.el-dialog__title {
  color: #2f4ad8 !important;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.02em;
}

.el-dialog__body {
  color: #3d52c4 !important;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.7;
  padding: 16px 20px 20px !important;
}

.el-dialog__headerbtn .el-dialog__close {
  color: #4253ff !important;
}

.el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close {
  color: #2f4ad8 !important;
}

.el-notification {
  background: #fff !important;
  border: 1px solid rgba(66, 83, 255, 0.18) !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 28px rgba(10, 28, 68, 0.12) !important;
}

.el-notification__title {
  color: #2f4ad8 !important;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.el-notification__content {
  color: #3d52c4 !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.65;
}
</style>